
import { Vue, Component } from "vue-property-decorator"

@Component
export default class Header2 extends Vue {}
